import React from 'react';
import { Row, Alert } from 'react-bootstrap';
import { StylishNewButton } from '../../../DesignSystems/New/StylishNewButton';
import { ApprovalStage } from '../utils/ResourceRequestTypes';
import { getStageName, getStageIcon } from '../utils/ResourceRequestUtils';
import ApprovalAuthorityWarning from '../../../DesignSystems/ApprovalAuthorityWarning';

interface ResourceRequestFormSectionProps {
  stage: ApprovalStage;
  currentStage: ApprovalStage;
  isCompleted: boolean;
  completedBy?: {
    name?: string;
    position?: string;
    signature?: string;
    timestamp?: Date;
  };
  onApprove?: () => void;
  isSubmitting?: boolean;
  children: React.ReactNode;
  className?: string;
  hasApprovalAuthority?: boolean;
}

const ResourceRequestFormSection: React.FC<ResourceRequestFormSectionProps> = ({
  stage,
  currentStage,
  isCompleted,
  completedBy,
  onApprove,
  isSubmitting,
  children,
  className = '',
  hasApprovalAuthority = true,
}) => {
  const isCurrentStage = currentStage === stage;
  const stageName = getStageName(stage);
  const stageIcon = getStageIcon(stage);

  return (
    <div
      className={`border rounded p-3 mb-3 ${
        isCurrentStage ? 'border-primary border-2' : ''
      } ${className}`}
    >
      <h5 className="mb-2">
        {stageIcon} {stageName}
      </h5>

      {isCompleted && completedBy ? (
        <>
          <Alert variant="success">
            <small>
              Completed by {completedBy.name} ({completedBy.position}) on{' '}
              {completedBy.timestamp &&
                new Date(completedBy.timestamp).toLocaleString()}
            </small>
          </Alert>
          <Row>
            <div className="col-6">
              <label className="form-label">Name</label>
              <input
                className="form-control"
                value={completedBy.name || ''}
                disabled
              />
            </div>
            <div className="col-6">
              <label className="form-label">Position</label>
              <input
                className="form-control"
                value={completedBy.position || ''}
                disabled
              />
            </div>
          </Row>
          {children}
        </>
      ) : (
        <>
          {children}
          {isCurrentStage && (
            <Row className="mt-3">
              <div className="col-12">
                {!hasApprovalAuthority ? (
                  <ApprovalAuthorityWarning
                    message="You don't have permission to approve resource requests. Please seek permission from a user with approval authority in the incident roster."
                    className="mb-3"
                  />
                ) : (
                  onApprove && (
                    <StylishNewButton
                      className="button--primary"
                      onClick={onApprove}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Approving...' : 'Approve'}
                    </StylishNewButton>
                  )
                )}
              </div>
            </Row>
          )}
        </>
      )}
    </div>
  );
};

export default ResourceRequestFormSection;
